import { db, FirebaseDocRefType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { PointCardCodeType as BasicPointCardCodeType } from 'types/pointCard/pointCardCode'

type PointCardCodeType = BasicPointCardCodeType & { ref: FirebaseDocRefType }

const PointCardCodeConverter = getConverter<PointCardCodeType>()

export const fetchPointCardCode = (pointCardId: string, id: string): Promise<PointCardCodeType | undefined> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_codes')
    .doc(id)
    .withConverter(PointCardCodeConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return undefined
      }
      return {
        ...data,
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchPointCardCodes = (pointCardId: string): Promise<PointCardCodeType[]> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_codes')
    .withConverter(PointCardCodeConverter)
    .orderBy('created_at', 'asc')
    .get()
    .then((snapshots) =>
      snapshots.docs.map((snapshot) => {
        const data = snapshot.data()
        return {
          ...data,
          ref: snapshot.ref,
        }
      })
    )
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const setPointCardCode = (pointCardCode: PointCardCodeType): Promise<void> => {
  const { ref, ...rest } = pointCardCode
  return ref.set(rest, { merge: true })
}

export const deletePointCardCode = (pointCardId: string, id: string): Promise<void> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_codes')
    .doc(id)
    .delete()
    .catch((error) => {
      console.error(error)
    })
}

export const fetchPointCardCodeForInStore = (pointCardId: string): Promise<PointCardCodeType | undefined> => {
  return db
    .collection('point_cards')
    .doc(pointCardId)
    .collection('point_card_codes')
    .where('is_in_store', '==', true)
    .withConverter(PointCardCodeConverter)
    .get()
    .then((snapshots) => {
      if (snapshots.docs.length === 0) {
        return undefined
      }
      const data = snapshots.docs[0].data()
      return {
        ...data,
        ref: data.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}
